import styled from 'styled-components';
import {
  PlusOutlined,
  LoadingOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { message, Button } from 'antd';
import { useEffect, useState, useRef } from 'react';
import { getPersonalInfo, getMfInfo, UploadAvatar, companySetLogo } from '../../../api/User';
import { useTranslation } from 'react-i18next';
import { avatarUpload } from '../../../api/files';
import { useSelector } from 'react-redux';
import { currentUser } from '../../../features/user/userSlice';

const UploadAvaterContainer = styled.div`
  margin: 20px;
  @media screen and (max-width: 768px) {
    padding: 10px 20px;
  }
`;

// const getBase64 = (img, callback) => {
//   const reader = new FileReader();
//   reader.addEventListener('load', () => callback(reader.result));
//   reader.readAsDataURL(img);
// };

const beforeUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }

  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }

  return isJpgOrPng && isLt2M;
  // return false;
};

const ImgContainer = styled.div`
  width: 140px;
  height: 140px;
  /* background-color: #fff; */
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #4b555e;
  border-radius: 4px;
  margin-right: 24px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
`;

const FileInput = styled.input`
  clip: rect(0, 0, 0, 0);
  position: absolute;
`;

const FileLabel = styled.label`
  height: 42px;
  line-height: 42px;
  padding: 0 20px;
  border: 1px solid #4b555e;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 24px;
`;

const FileName = styled.label`
  height: 42px;
  line-height: 42px;
  color: #4b555e;
`;

const FilesContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: 40px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    min-height: 300px;
  }
`;

const UploadAvater = () => {
  const { t } = useTranslation();
  const [filesLoading, setFilesLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [filesID, setFilesID] = useState();
  const fileInput = useRef();
  const _USER = useSelector(currentUser);

  const fetchFileId = async () => {
    setFilesLoading(true);
    const formData = new FormData();
    formData.append('image', fileInput.current.files[0]);
    try {
      const { code, data } = await avatarUpload(formData);
      if (code === '10000') {
        setFilesID(data.file_id);
        FileChange();
      }
    } catch (error) {
      // console.log(error);
    }
    setFilesLoading(false);
  };

  const getUserInfo = async () => {
    if(_USER.user.type === 0){
      try {
        const { code, data } = await getPersonalInfo();
        if (code === '10000') {
          setImageUrl(data.avatar)
        }
      } catch (error) {
        setLoading(false);
      }
      setLoading(false);
    }else{
      try {
        const { code, data } = await getMfInfo();
        if (code === '10000') {
          setImageUrl(data.avatar)
        }
      } catch (error) {
        setLoading(false);
      }
      setLoading(false);
    }
    
  };

  useEffect(() => {
      getUserInfo()
  }, [])

  const FileChange = () => {
    const img = fileInput.current.files[0];
    if (img && beforeUpload(img)) {
      const url = URL.createObjectURL(img);
      setImageUrl(url);
    }
  };

  const handleUpload = async () => {
    if(!filesID){
      message.error('No file selected');
      return;
    }
    setLoading(true);
    let metName;
    const formData = new FormData();
    if (_USER.user.type === 0) {
      metName = UploadAvatar;
      formData.append('avatar_file_id', filesID);
    } else {
      metName = companySetLogo;
      formData.append('logo_file_id', filesID);
    }
    try {
      const { code } = await metName(formData);
      if (code === '10000') {
        message.success(t('user_center.setAvatar.message.success'));
      }
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
  };
  return (
    <UploadAvaterContainer>
      <FilesContainer>
        <ImgContainer>
          {imageUrl ? (
            <img src={imageUrl} />
          ) : filesLoading ? (
            <LoadingOutlined />
          ) : (
            <label
              htmlFor={'fileInput'}
              style={{
                width: '100%',
                height: '100%',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <PlusOutlined />
            </label>
          )}
        </ImgContainer>
        <FileInput
          type={'file'}
          id={'fileInput'}
          onChange={fetchFileId}
          ref={fileInput}
        />
        <FileLabel htmlFor={'fileInput'}>
          {t('user_center.setAvatar.selectFile')}
        </FileLabel>
      </FilesContainer>
      <Button
        type="primary"
        loading={loading}
        style={{
          backgroundColor: '#18EAC4',
          color: '#000000',
          borderColor: '#18EAC4',
          borderRadius: '4px',
        }}
        onClick={handleUpload}
      >
        {t('user_center.setAvatar.submit')}
      </Button>
    </UploadAvaterContainer>
  );
};

export default UploadAvater;
